export default "__VITE_ASSET__CHUDUXHg__"